import React, { useState } from 'react';
import { HiInformationCircle } from "react-icons/hi"

const InfoPoint = ({ title, information }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative border-t border-gray-300 pt-10 flex items-center">
      <h1 className="mt-4 text-md font-medium text-gray-700 flex items-center">
        {title}
        <span
          className="text-2xl cursor-pointer ml-2"
          onClick={() => setIsHovered(!isHovered)}
          // onMouseEnter={() => setIsHovered(true)}
          // onMouseLeave={() => setIsHovered(false)}
        >
          <HiInformationCircle />
        </span>
        {isHovered && (
          <span className="bg-white w-96 p-2 ml-2 rounded-md border border-gray-300 shadow-sm sm:text-md focus:outline-none">
            {/* Textarea */}
            {information}
          </span>
        )}
      </h1>
    </div>
  );
};


export default InfoPoint;
